import classNames from 'classnames';
import PropTypes from 'prop-types';

const VideoIcon = ({ className }) => {
  const iconClassName = classNames('video-icon', className);

  return (
    <svg className={iconClassName} width='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1 0.25H6.7331L4.55309 4.25H0.25V1C0.25 0.585786 0.585786 0.25 1 0.25Z' fill='currentColor' />
      <path d='M11.5531 4.25H6.26139L8.44141 0.25H13.7331L11.5531 4.25Z' fill='currentColor' />
      <path d='M15.4414 0.25L13.2614 4.25H19.75V1C19.75 0.585786 19.4142 0.25 19 0.25H15.4414Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.75 5.75H0.25V19C0.25 19.4142 0.585786 19.75 1 19.75H19C19.4142 19.75 19.75 19.4142 19.75 19V5.75ZM13.5 12.5L8 9V16L13.5 12.5Z'
        fill='currentColor'
      />
    </svg>
  );
};

VideoIcon.propTypes = {
  className: PropTypes.string,
};

export default VideoIcon;
